module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

if(getLayoutClass() === 'side_left' || getLayoutClass() === 'side_right'){;
__p += '\n	<div id="interactive_region"></div>\n	<div id="widget_header_wrapper" class="' +
((__t = (getLayoutClass())) == null ? '' : __t) +
'">\n		<div id="widget_header_region"></div>\n		<div aria-label="Carousel of images with text descriptions and social media handles." class="wrap" id="carousel_widget" role="region"></div>\n	</div>\n';
} else { ;
__p += '\n	<div id="widget_header_region"></div>\n	<div id="interactive_region"></div>\n	<div aria-label="Carousel of images with text descriptions and social media handles." class="wrap" id="carousel_widget" role="region"></div>\n';
};
__p += '\n';

}
return __p
}